import React, { useState } from "react";
import "./styles.css";


function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}

function managehome(){
  document.getElementById('home').style.display="block";
  document.getElementById('ssvg').style.display="block";
  document.getElementById('aboutus').style.display="none";
  document.getElementById("mySidenav").style.width = "0";

}

function manageabout(){
  document.getElementById('aboutus').style.display="block";
  document.getElementById('home').style.display="none";
  document.getElementById('ssvg').style.display="none";
  document.getElementById("mySidenav").style.width = "0";

}


function Nav(){
   
    return(
      <div>
      
          <div id="blur" className="navi">
             <ul className="main-nav" >
             <li className="main-nav-li" ><img className="liidea" src="../images/idea.svg"></img></li>
                 <li className="main-nav-li" >
          
                  <b> <a href="#" className="litext"> The Keeper </a> </b>
                 </li>
                 
                 <li  className="nav-dis "> <a href="javascript:void(0)"  onClick={openNav}><img src="../images/menu.svg"></img></a> </li>
                 
             </ul>
           </div>
           
          
            <div id="mySidenav" class="sidenav" >
              <button className="closebtn" onClick={closeNav}><img src="../images/x.svg"></img></button>
              <a className="nav-link"  href="#home"  onClick={managehome} >
              <svg  width="40" height="40" viewBox="0 0 24 24" fill="none" stroke-width="1.0" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
              <span className="slide-icon">HOME</span> </a>
           
              <a className="nav-link" href="#aboutus" onClick={manageabout} >
              <svg   width="40" height="40" viewBox="0 0 24 24" fill="none"  stroke-width="1.0" stroke-linecap="round" stroke-linejoin="round" ><circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line></svg>
              <span className="slide-icon2">ABOUT US</span> </a>
 
             </div>
      </div>
);


}

export default Nav;